import React from 'react'
import {Box} from '../../webui/Box'
import {Button} from '../../webui/Button'
import {TextField} from '../../webui/inputs/TextField'
import {AllUsers} from './AllUsers'

interface Props {}

export const AllUsersWithSearch: React.FC<Props> = () => {
  const [emailInput, setEmailInput] = React.useState('')
  const [nameInput, setNameInput] = React.useState('')
  const [emailSearch, setEmailSearch] = React.useState<string | undefined>()
  const [nameSearch, setNameSearch] = React.useState<string | undefined>()

  const triggerSearch = () => {
    setEmailSearch(emailInput.trim() || undefined)
    setNameSearch(nameInput.trim() || undefined)
  }

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      triggerSearch()
    }
  }

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" alignItems="flex-end" gap={2}>
        <TextField label="Email contains" value={emailInput} onChange={setEmailInput} onKeyDown={onKeyDown} />
        <TextField label="Name contains" value={nameInput} onChange={setNameInput} onKeyDown={onKeyDown} />
        <Button onClick={triggerSearch}>Search</Button>
      </Box>

      <AllUsers emailSearch={emailSearch} nameSearch={nameSearch} />
    </Box>
  )
}
